import {
  ADFORM_PREBID_BIDDER,
  RTBHOUSE_PREBID_BIDDER,
  TABOOLA_PREBID_BIDDER,
  TURK_TELEKOM_PREBID_BIDDER,
  YANDEX_PREBID_BIDDER,
  INDEX_EXCHANGE_BIDDER,
  PUBMATIC_PREBID_BIDDER,
  THEADX_PREBID_BIDDER,
  ADMATIC_PREBID_BIDDER,
  ESKIMI_PREBID_BIDDER,
} from '../bidders';

export const homepageAdUnits = {
  desktop: {
    mansetAlti: {
      name: 'Anasayfa_Mansetalti_Bant',
      sizes: [
        [1100, 250],
        [980, 300],
        [980, 250],
        [1100, 300],
        [970, 250],
      ],
      divId: 'homepage-mansetalti',
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1010076),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_masthead_2'),
          INDEX_EXCHANGE_BIDDER(1042156),
          PUBMATIC_PREBID_BIDDER(5508960),
          THEADX_PREBID_BIDDER(755),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Bant',
          sizes: [[1100, 250], [1100, 130], [980, 250], [970, 90], [970, 250], [728, 90], 'fluid'],
        },
      },
    },
    sliderArasi: {
      name: 'Onedio.com_Manset_Slider',
      sizes: ['fluid'],
    },
    trendTop: {
      name: 'Onedio.com_Desktop_Homepage_Trend_Native_Top',
      sizes: ['fluid'],
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Homepage_Trend_Native',
          sizes: [[320, 100], 'fluid', [300, 100], [300, 75], [300, 50], [320, 50]],
        },
      },
    },
    trendMiddle: {
      name: 'Onedio.com_Desktop_Homepage_Trend_Native_Middle',
      sizes: ['fluid'],
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Homepage_Trend_Native',
          sizes: [[320, 100], 'fluid', [300, 100], [300, 75], [300, 50], [320, 50]],
        },
      },
    },
    masthead2: {
      name: 'Onedio.com_Desktop_Masthead_2',
      sizes: [
        [1100, 250],
        [980, 300],
        [970, 130],
        [728, 90],
        [970, 250],
        [940, 250],
        [970, 90],
        [980, 250],
        [1100, 300],
      ],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1010076),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_masthead_3'),
          INDEX_EXCHANGE_BIDDER(1042156),
          PUBMATIC_PREBID_BIDDER(5508960),
          THEADX_PREBID_BIDDER(755),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Masthead_2',
          sizes: [[1100, 130], 'fluid', [1100, 250], [980, 250], [970, 130], [970, 250], [940, 250], [970, 90], [728, 90]],
        },
      },
    },
    masthead3: {
      name: 'Onedio.com_Desktop_Masthead_3',
      sizes: [
        [1100, 300],
        [980, 300],
        [728, 90],
        [940, 250],
        [970, 130],
        [970, 250],
        [970, 90],
        [980, 250],
        [1100, 250],
      ],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1010076),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_masthead_4'),
          INDEX_EXCHANGE_BIDDER(1042156),
          PUBMATIC_PREBID_BIDDER(5508960),
          THEADX_PREBID_BIDDER(755),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Masthead_2',
          sizes: [[1100, 130], 'fluid', [1100, 250], [980, 250], [970, 130], [970, 250], [940, 250], [970, 90], [728, 90]],
        },
      },
    },
    masthead4: {
      name: 'Onedio.com_Desktop_Masthead_4',
      sizes: [
        [940, 250],
        [970, 130],
        [980, 250],
        [980, 300],
        [1100, 300],
        [1100, 250],
        [728, 90],
        [970, 90],
        [970, 250],
      ],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1010076),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_masthead_5'),
          INDEX_EXCHANGE_BIDDER(1042156),
          PUBMATIC_PREBID_BIDDER(5508960),
          THEADX_PREBID_BIDDER(755),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Masthead_2',
          sizes: [[1100, 130], 'fluid', [1100, 250], [980, 250], [970, 130], [970, 250], [940, 250], [970, 90], [728, 90]],
        },
      },
    },
    widget10Top: {
      name: 'Onedio.com_Desktop_Homepage_Widget10_Native_Top',
      sizes: ['fluid'],
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Homepage_Widget10_Native_Top',
          sizes: [[300, 75], [300, 50], 'fluid', [300, 100], [320, 100], [320, 50]],
        },
      },
    },
    widget10Middle: {
      name: 'Onedio.com_Desktop_Homepage_Widget10_Native_Middle',
      sizes: ['fluid'],
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Homepage_Widget10_Native_Middle',
          sizes: [[300, 100], [320, 100], [300, 50], [320, 50], [344, 142], [300, 75], 'fluid'],
        },
      },
    },
    widget6Middle: {
      name: 'Onedio.com_Desktop_Homepage_Widget6_Native_Middle',
      sizes: ['fluid'],
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Homepage_Widget6_Native_Middle',
          sizes: ['fluid', [300, 250], [336, 280]],
        },
      },
    },
  },
  mobile: {
    mansetAlti: {
      name: 'onedio.com_mobil_ilk_mansetalti_bant',
      sizes: [[320, 100], [300, 100], [320, 150], [344, 150], [300, 150], [320, 50], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1012352),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          TABOOLA_PREBID_BIDDER('m_masthead_2'),
          INDEX_EXCHANGE_BIDDER(1042152),
          PUBMATIC_PREBID_BIDDER(5508963),
          THEADX_PREBID_BIDDER(758),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Bant',
          sizes: [[300, 100], [300, 150], [300, 250], [320, 100], [320, 150], [320, 50], 'fluid'],
        },
      },
    },
    anasayfaBTF: {
      name: 'Onedio.com_Mobile_Masthead_Anasayfa_BTF',
      sizes: [[320, 100], [300, 100], [300, 150], [300, 250], [336, 280], [320, 480], 'fluid'],
    },
    appPromo: {
      name: 'Onedio.com_Mobile_PopUp_AppPromo',
      sizes: [1, 1],
    },
    sliderArasi: {
      name: 'Onedio.com_Manset_Slider',
      sizes: ['fluid'],
    },
    trendTop: {
      name: 'Onedio.com_Mobile_Homepage_Trend_Native_Top',
      sizes: [[300, 250], [344, 150], [320, 100], [320, 150], [300, 100], 'fluid', [300, 150], [336, 280], [344, 142]],
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Homepage_Trend_Native_Top',
          sizes: [
            [344, 142],
            [300, 150],
            [320, 100],
            [300, 100],
            [320, 150],
            [300, 50],
            [344, 150],
            [320, 50],
            'fluid',
            [300, 250],
            [336, 280],
          ],
        },
      },
    },
    trendMiddle: {
      name: 'Onedio.com_Mobile_Homepage_Trend_Native_Middle',
      sizes: [[300, 75], [300, 100], [300, 50], [320, 50], [320, 100], 'fluid'],
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Homepage_Trend_Native_Middle',
          sizes: ['fluid', [320, 50], [300, 75], [300, 100], [300, 50], [320, 100]],
        },
      },
    },
    masthead2: {
      name: 'Onedio.com_Mobile_Masthead_2',
      sizes: [[320, 50], [320, 100], 'fluid', [320, 150], [300, 150], [344, 142], [300, 100], [300, 50], [344, 150]],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1012352),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          TABOOLA_PREBID_BIDDER('m_masthead_3'),
          INDEX_EXCHANGE_BIDDER(1042152),
          PUBMATIC_PREBID_BIDDER(5508963),
          THEADX_PREBID_BIDDER(758),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Masthead_2',
          sizes: [[320, 150], [300, 100], [344, 142], [300, 75], [300, 150], 'fluid', [344, 150], [320, 50], [300, 50], [320, 100]],
        },
      },
    },
    masthead3: {
      name: 'Onedio.com_Mobile_Masthead_3',
      sizes: [[300, 100], [344, 150], [300, 50], [320, 50], [344, 142], [320, 100], [320, 150], 'fluid', [300, 150]],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1012352),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          TABOOLA_PREBID_BIDDER('m_masthead_4'),
          INDEX_EXCHANGE_BIDDER(1042152),
          PUBMATIC_PREBID_BIDDER(5508963),
          THEADX_PREBID_BIDDER(758),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Masthead_2',
          sizes: [[320, 150], [300, 100], [344, 142], [300, 75], [300, 150], 'fluid', [344, 150], [320, 50], [300, 50], [320, 100]],
        },
      },
    },
    widget10Top: {
      name: 'Onedio.com_Mobile_Homepage_Widget10_Native_Top',
      sizes: [[320, 100], [320, 150], 'fluid', [336, 280], [344, 150], [300, 250], [300, 100], [344, 142], [300, 150]],
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Homepage_Widget10_Native_Top',
          sizes: [
            [320, 100],
            [320, 50],
            [344, 142],
            [300, 50],
            'fluid',
            [300, 100],
            [344, 150],
            [300, 150],
            [300, 250],
            [300, 75],
            [336, 280],
          ],
        },
      },
    },
    widget10Middle: {
      name: 'Onedio.com_Mobile_Homepage_Widget10_Native_Middle',
      sizes: [[320, 100], [300, 100], [300, 75], [300, 50], [320, 50], 'fluid'],
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Homepage_Widget10_Native_Middle',
          sizes: [[300, 100], [320, 50], [320, 100], [300, 50], [300, 75], 'fluid'],
        },
      },
    },
    widget6Middle: {
      name: 'Onedio.com_Mobile_Homepage_Widget6_Native_Middle',
      sizes: ['fluid', [300, 100], [300, 50], [300, 75], [320, 100], [320, 50]],
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Homepage_Widget6_Native_Middle',
          sizes: ['fluid', [300, 50], [320, 100], [300, 75], [300, 100], [320, 50]],
        },
      },
    },
  },
};
